export default __webpack_public_path__ + "static/media/jan-sendereks.d8540b7e.jpg";